import { EventSchema } from '../../interfaces/EventInterfaces';
import { EVENT_NAME as EN } from '../../constants/EventName';
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey';
import { CommonEventProperties } from '../../utils/CommonParams';

export const ProductClickedEventSchema: EventSchema = {
    eventName: EN.PRODUCT_CLICKED,
    params: {
        ...CommonEventProperties,
        BUSINESS_VERTICAL: EPK.BUSINESS_VERTICAL,
        EVENT_CATEGORY: EPK.EVENT_CATEGORY,
        PRODUCTS : EPK.PRODUCTS,
        INDEX: EPK.INDEX,
        EVENT_TYPE: EPK.EVENT_TYPE,
        QUERY_ID: EPK.QUERY_ID,
    }
}